var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',{staticClass:"icon stroke-current",attrs:{"width":"24","height":"24","viewBox":"0 0 24 24","fill":"none","xmlns":"http://www.w3.org/2000/svg"}},[_c('path',{attrs:{"d":"M9.5 7L14.5 12L9.5 17","stroke-width":"2"}}),_c('circle',{attrs:{"cx":"12","cy":"12","r":"11.5"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }